var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -3434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 3434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(278.811 3445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.52,389.395a.519.519,0,0,0-.52.515v8.549a.519.519,0,0,0,.52.515H9.147a.519.519,0,0,0,.52-.515v-9.064Zm0,0",
    transform: "translate(0 -358.973)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.168,301.176a6.172,6.172,0,0,1,1.158-3.68,6.9,6.9,0,0,1-4.057.554v3.474a10.465,10.465,0,0,0,2.9-.089Zm0,0",
    transform: "translate(-170.795 -274.255)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.264,276.594a8.142,8.142,0,0,1-3.5.789h-2.421a9.309,9.309,0,0,1-3.373-.608,6.142,6.142,0,0,0-2.6,5.132v1.1l.323.032-.041-.117-.06-.158a.587.587,0,0,1,.341-.756l.169-.064a.584.584,0,0,1,.207-.038.59.59,0,0,1,.549.38l.646,1.689.006.008a2.17,2.17,0,0,1,.186.32l.016.034.036.009a6.475,6.475,0,0,0,1.587.2,6.557,6.557,0,0,0,5.847-3.611,1.566,1.566,0,0,1,2.082-.712,1.532,1.532,0,0,1,.71,2.06,9.54,9.54,0,0,1-3.621,3.94,9.728,9.728,0,0,1-5.036,1.407h0a9.588,9.588,0,0,1-1.987-.209v3.161h1.38l.008-.069a1.639,1.639,0,0,1,3.075-.561l.069.132.069-.132a1.639,1.639,0,0,1,3.075.561l.008.069h5.056v-8.75A6.036,6.036,0,0,0,233.264,276.594Zm0,0",
    transform: "translate(-204.08 -254.985)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.7,285.17l-.041-.117-.06-.158a.587.587,0,0,1,.341-.756l.169-.064a.583.583,0,0,1,.207-.038.59.59,0,0,1,.549.38l.646,1.689.006.008a2.174,2.174,0,0,1,.186.32l.016.034.036.009.095.023v-2.459a6.141,6.141,0,0,1,1.989-4.638,8.835,8.835,0,0,1-1.866-.494,6.142,6.142,0,0,0-2.6,5.132v1.1Zm0,0",
    transform: "translate(-204.08 -257.117)",
    fill: "#0cb2c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75,437.014a1.593,1.593,0,0,1,.159-.691,1.716,1.716,0,0,0-3.266.5h-1.31v3.972a.519.519,0,0,1-.52.515h3.648V441.3a1.712,1.712,0,0,0,1.447-1,1.591,1.591,0,0,1-.158-.688Zm0,0",
    transform: "translate(-221.077 -401.307)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.6,441.3v.006h6.944a2.244,2.244,0,1,0,0-4.487h-5.125a1.714,1.714,0,0,0-3.415.193v2.6A1.7,1.7,0,0,0,303.6,441.3Zm0,0",
    transform: "translate(-278.413 -401.308)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.46,439.61v-2.6a1.684,1.684,0,0,1,.487-1.184,1.715,1.715,0,0,0-2.939,1.184v2.6a1.7,1.7,0,0,0,1.6,1.692v.006h2.452V441.3A1.7,1.7,0,0,1,304.46,439.61Zm0,0",
    transform: "translate(-278.414 -401.307)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.087,285.957h-2.421a10.082,10.082,0,0,1-1.112-.063v.068a1.958,1.958,0,0,0,3.916,0v-.016C287.343,285.953,287.215,285.957,287.087,285.957Zm0,0",
    transform: "translate(-261.401 -263.559)",
    fill: "#ffc987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.537,84.475H211.5V83.331c0-.087,0-.174,0-.261a2.052,2.052,0,0,1-.594.327,4.272,4.272,0,0,1-1.42.261h0c-2.46,0-3.573-2.588-3.584-2.614l-.074-.176-.071.178c-.013.034-1.363,3.356-3.616,3.356a2.505,2.505,0,0,1-.752-.12c-1.068-.337-1.422-1.149-1.05-2.415L200.2,81.8c-.692,1.156-1.755,2.534-2.882,2.534a1.392,1.392,0,0,1-.392-.056,1.364,1.364,0,0,1-.893-.728,3.163,3.163,0,0,1,.187-2.45l-.143-.063c-.933,1.957-1.927,2.908-3.037,2.908a1.977,1.977,0,0,1-.381-.038v4.932c0,5.314,3.677,8.184,8.213,8.184h2.421a8.211,8.211,0,0,0,7.94-6.086,2.038,2.038,0,0,0,.306.024c1.407,0,2.547-1.453,2.547-3.244s-1.14-3.244-2.547-3.244Zm0,0",
    transform: "translate(-177.605 -74.55)",
    fill: "#ffd5b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12,109.526v-5.511c0-.24.011-.477.031-.711a2.708,2.708,0,0,1-2.113,1.328,1.976,1.976,0,0,1-.381-.038v4.932c0,5.314,3.677,8.184,8.213,8.184H203.3c-4.522-.012-8.184-2.88-8.184-8.183Zm0,0",
    transform: "translate(-177.605 -95.234)",
    fill: "#e5bfa1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.668 12.017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.59,155.982A.586.586,0,0,1,345,155.4v-.99a.586.586,0,0,1,1.172,0v.99A.586.586,0,0,1,345.59,155.982Zm0,0",
    transform: "translate(-336.085 -153.82)",
    fill: "#775436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.426,155.982a.586.586,0,0,1-.586-.586v-.99a.586.586,0,0,1,1.172,0v.99A.586.586,0,0,1,231.426,155.982Zm0,0",
    transform: "translate(-229.84 -153.82)",
    fill: "#775436"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.549,216.054a2.755,2.755,0,0,1-2.764-2.739.518.518,0,0,1,.52-.515h4.489a.517.517,0,0,1,.52.515A2.754,2.754,0,0,1,264.549,216.054Zm0,0",
    transform: "translate(-241.333 -196.176)",
    fill: "#fb8276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.266,213.32a.517.517,0,0,1,.52-.515H262.3a.517.517,0,0,0-.52.515,2.767,2.767,0,0,0,4,2.447A2.74,2.74,0,0,1,264.266,213.32Zm0,0",
    transform: "translate(-241.333 -196.18)",
    fill: "#e1756a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.984,0h-2.619a8.868,8.868,0,0,0-8.885,8.852v.132a2.394,2.394,0,0,0,.582.325c1.883.746,3.155-1.148,3.936-2.785-.581,1.408-.562,2.9.757,3.282,1.272.371,2.493-1.061,3.363-2.512-.3,1.014-.232,2.091,1.1,2.512,2.806.885,4.464-3.282,4.464-3.282s1.53,3.661,5.1,2.4a2.071,2.071,0,0,0,1.05-.808A8.871,8.871,0,0,0,190.984,0Zm0,0",
    transform: "translate(-165.459 0)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.935,8.984V8.852A8.868,8.868,0,0,1,190.819,0h-2.454a8.868,8.868,0,0,0-8.885,8.852v.132a2.394,2.394,0,0,0,.582.325,2.073,2.073,0,0,0,2.023-.219c-.052-.034-.1-.069-.151-.105Zm0,0",
    transform: "translate(-165.459 0)",
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.094,246.564V245.9a1.138,1.138,0,0,0-1.143-1.133H89.624A1.138,1.138,0,0,0,88.48,245.9v.666Zm0,0",
    transform: "translate(-81.568 -225.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.971,246.564V245.9a1.138,1.138,0,0,1,1.143-1.133H89.62a1.138,1.138,0,0,0-1.143,1.133v.666Zm0,0",
    transform: "translate(-81.564 -225.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2,275.853a.519.519,0,0,1-.52.515H63.054a.519.519,0,0,1-.52-.515V267.3a.519.519,0,0,1,.52-.515h8.628a.519.519,0,0,1,.52.515Zm0,0",
    transform: "translate(-57.649 -245.947)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.235,302.607a.294.294,0,0,1-.138-.034l-1.226-.635-1.226.635a.294.294,0,0,1-.138.034.3.3,0,0,1-.174-.056.289.289,0,0,1-.118-.285l.234-1.345-.992-.953a.289.289,0,0,1-.075-.3.3.3,0,0,1,.239-.2l1.371-.2.613-1.224a.3.3,0,0,1,.531,0l.613,1.224,1.371.2a.3.3,0,0,1,.239.2.287.287,0,0,1-.075.3l-.992.953.234,1.345a.289.289,0,0,1-.117.285.3.3,0,0,1-.174.056Zm0,0",
    transform: "translate(-85.153 -274.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.911,398.458v-8.549a.519.519,0,0,1,.52-.515H.52a.519.519,0,0,0-.52.515v8.549a.519.519,0,0,0,.52.515H2.431A.519.519,0,0,1,1.911,398.458Zm0,0",
    transform: "translate(0 -358.973)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,426.8a.246.246,0,0,1-.172-.07l-2.161-2.113a1.294,1.294,0,0,1,0-1.857,1.364,1.364,0,0,1,1.9,0l.434.425.435-.425a1.364,1.364,0,0,1,1.9,0,1.294,1.294,0,0,1,0,1.857l-2.161,2.113a.247.247,0,0,1-.173.07Zm0,0",
    transform: "translate(-24.869 -389.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.477,391.185l-.024-.008-.024.008a2.222,2.222,0,0,1-.93.1l-2-.2a.539.539,0,0,1-.482-.589l.017-.167a.536.536,0,0,1,.535-.484l.055,0,1.523.153.027-.263-1.841-.185a.533.533,0,0,1-.332-.161h-5.261v9.064a.519.519,0,0,0,.52.515h8.628a.519.519,0,0,0,.519-.515v-7.038C133.092,391.357,132.783,391.28,132.477,391.185Zm0,0",
    transform: "translate(-114.071 -358.974)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.886,398.458v-9.063h-2.148v9.064a.519.519,0,0,0,.52.515h2.148A.519.519,0,0,1,125.886,398.458Zm0,0",
    transform: "translate(-114.071 -358.973)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.613,427.1a1,1,0,0,1-.779-.446l-.753-1.293a.982.982,0,0,1,0-.892l.753-1.293a1,1,0,0,1,.779-.446h1.506a1,1,0,0,1,.78.446l.753,1.293a.98.98,0,0,1,0,.892l-.753,1.293a1,1,0,0,1-.78.446Zm0,0",
    transform: "translate(-142.865 -389.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6,275.853V267.3a.519.519,0,0,1,.52-.515H63.055a.519.519,0,0,0-.52.515v8.549a.519.519,0,0,0,.52.515h2.064A.519.519,0,0,1,64.6,275.853Zm0,0",
    transform: "translate(-57.65 -245.947)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.75,154.419a.586.586,0,0,1-.279-1.1c.663-.359.277-1.273.261-1.312a.586.586,0,1,1,1.075-.465,2.975,2.975,0,0,1,.217,1.014,1.874,1.874,0,0,1-1,1.794A.581.581,0,0,1,426.75,154.419Zm0,0",
    transform: "translate(-392.869 -139.376)",
    fill: "#ffb98a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.629,320.148a1.644,1.644,0,0,0-2.186.748A6.452,6.452,0,0,1,235,324.244a2.1,2.1,0,0,1,.22,1.157,2.125,2.125,0,0,1-1.556,1.831,9.745,9.745,0,0,0,11.714-4.918,1.609,1.609,0,0,0-.746-2.165Zm0,0",
    transform: "translate(-215.406 -294.986)",
    fill: "#0cb2c2",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.305,348.24l.017-.167a.616.616,0,0,1,.675-.551l1.445.145.011-.107-1.764-.178a.616.616,0,0,1-.551-.674l.017-.167a.616.616,0,0,1,.675-.551l1.763.178.011-.108-1.445-.145a.616.616,0,0,1-.551-.675l.017-.167a.617.617,0,0,1,.675-.551l1.638.165h0l-.06-.158a.665.665,0,0,1,.387-.857l.17-.064a.665.665,0,0,1,.857.387l.642,1.68a2.174,2.174,0,0,1,.389,1.472,2.234,2.234,0,0,1-2.469,1.971l-2-.2A.616.616,0,0,1,188.305,348.24Zm0,0",
    transform: "translate(-173.437 -316.722)",
    fill: "#ffd5b3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby7);
export default __webpack_public_path__ + "static/media/baby7.ba9dcd78b78d1fd372b2096d1dbb2f95.svg";
export { ForwardRef as ReactComponent };